module.exports = __webpack_public_path__ + "static/media/heart.ce070b7d.svg";